import { Routes, Route, useLocation } from 'react-router-dom'
import { useWebAuthBootstrap } from './AppBootstrap'
import { useAppStore } from '@/store/useAppStore'
import {
  useCategories,
  useCards,
  useFavorites,
  useAnnouncements,
  useSubscription,
} from '@/hooks/useApi'
import LoadingScreen from '@/components/LoadingScreen/LoadingScreen'
import ScrollToTop from '@/components/ScrollToTop'
import Layout from '@/components/Layout/Layout'
import HomePage from '@/pages/HomePage/HomePage'
import ProfilePage from '@/pages/ProfilePage/ProfilePage'
import CardPage from '@/pages/CardPage'
import SubscribePage from '@/pages/SubscribePage'
import CoursesPage from '@/pages/CoursesPage/CoursesPage'
import CourseDetailPage from '@/pages/CourseDetailPage/CourseDetailPage'
import WeddingLandingPage from '@/pages/CourseDetailPage/WeddingLandingPage'
import WeddingCourseV2Page from '@/pages/CourseDetailPage/WeddingCourseV2Page'
import LessonPage from '@/pages/LessonPage/LessonPage'
import FavoritesPage from '@/pages/FavoritesPage/FavoritesPage'
import FlavorsPage from '@/pages/FlavorsPage/FlavorsPage'
import BasePage from '@/pages/BasePage/BasePage'
import CalculatorPage from '@/pages/CalculatorPage/CalculatorPage'
import ShapeCalculatorPage from '@/pages/ShapeCalculatorPage/ShapeCalculatorPage'
import CostCalculatorPage from '@/pages/CostCalculatorPage/CostCalculatorPage'
import AssistantPage from '@/pages/AssistantPage/AssistantPage'
import AuthPage from '@pages/AuthPage/AuthPage'
import TermsPage from '@pages/TermsPage/TermsPage'
import PrivacyPage from '@pages/PrivacyPage/PrivacyPage'
import KinescopeTestPage from '@pages/KinescopeTestPage'
import { LinkTelegramConfirmScreen } from '@features/link-telegram/ui/LinkTelegramConfirmScreen'
import { PaymentStatusModal } from '@features/payments'
import { NpsSurveyHost } from '@features/nps-survey'
import { GracePeriodPopup } from '@/pages/ProfilePage/components/SubscriptionSection/GracePeriodPopup'
import AuthDebugPanel from '@/components/AuthDebugPanel/AuthDebugPanel'
import { ProtectedRoute } from './routes/ProtectedRoute'
import { PublicRoute } from './routes/PublicRoute'
import { WebBackButton } from '@/components/WebBackButton/WebBackButton'
import { useHorizontalWheelScroll } from '@/hooks'

export const WebAppShell = () => {
  const { status } = useWebAuthBootstrap()
  const location = useLocation()
  const authStatus = useAppStore(s => s.authStatus)
  const isAuthComplete = authStatus === 'success'

  // Легаси-хуки стреляют после установки authStatus=success в AppBootstrap.
  useCategories(isAuthComplete)
  useCards()
  useFavorites()
  useAnnouncements()
  useSubscription()

  // Колесом мыши горизонтальные ленты карточек не листались вовсе: полосы
  // прокрутки в них скрыты.
  useHorizontalWheelScroll()

  if (status === 'pending') {
    return <LoadingScreen isLoading={true} />
  }

  const shouldApplySafeArea =
    !location.pathname.startsWith('/card/') &&
    !location.pathname.startsWith('/subscribe') &&
    !location.pathname.match(/^\/courses\/\d/) &&
    !location.pathname.startsWith('/wc') &&
    !location.pathname.startsWith('/weddingcourse') &&
    !location.pathname.startsWith('/auth')

  return (
    <div className={shouldApplySafeArea ? 'safe-area-inset' : ''}>
      <ScrollToTop />
      <WebBackButton />
      <Routes>
        <Route
          path="auth"
          element={
            <PublicRoute>
              <AuthPage />
            </PublicRoute>
          }
        />
        <Route path="terms" element={<TermsPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        {/* Стенд для проверки трансляций: вне меню, открывается по прямой ссылке. */}
        <Route path="kinescope-test" element={<KinescopeTestPage />} />
        <Route path="wc" element={<WeddingLandingPage />} />
        <Route path="weddingcourse" element={<WeddingCourseV2Page />} />
        <Route
          path="link-telegram/confirm"
          element={<LinkTelegramConfirmScreen />}
        />

        <Route element={<ProtectedRoute />}>
          <Route path="card/:cardId" element={<CardPage />} />
          <Route path="courses/:courseId" element={<CourseDetailPage />} />
          <Route
            path="courses/:courseId/lesson/:lessonId"
            element={<LessonPage />}
          />
          <Route path="subscribe" element={<SubscribePage />} />
          <Route path="calculator/:cardId?" element={<CalculatorPage />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="courses" element={<CoursesPage />} />
            <Route path="favorites" element={<FavoritesPage />} />
            <Route path="base" element={<BasePage />} />
            <Route path="flavors" element={<FlavorsPage />} />
            <Route path="cost-calculator" element={<CostCalculatorPage />} />
            <Route path="shape-calculator" element={<ShapeCalculatorPage />} />
            <Route path="assistant" element={<AssistantPage />} />
          </Route>
        </Route>
      </Routes>
      <NpsSurveyHost />
      <PaymentStatusModal />
      <GracePeriodPopup />
      {/* <AuthDebugPanel /> */}
    </div>
  )
}
